__webpack_require__.p = "/marathi-typing/_next/";